var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsumo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 10C24.5 10 10.5 22.8667 10.5 40C10.5 47.0667 12.9667 53.5667 17.0667 58.7L10.5 65.3L15.2 70L21.7667 63.4333C27.0866 67.6818 33.6918 69.9972 40.5 70C48.1667 70 55.8667 67.0667 61.7 61.2C64.494 58.4224 66.7101 55.1189 68.2205 51.4802C69.7309 47.8415 70.5056 43.9397 70.5 40V10H40.5ZM63.8333 40C63.8333 46.2333 61.4 52.1 57 56.5C54.8375 58.6726 52.266 60.3951 49.4339 61.568C46.6018 62.7408 43.5653 63.3409 40.5 63.3333C27.6333 63.3333 17.1667 52.8667 17.1667 40C17.1667 33.6667 19.6333 27.7333 24.1667 23.3667C28.5114 19.062 34.3839 16.6531 40.5 16.6667H63.8333V40Z",
    fill: "url(#paint0_linear_18_45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7 42.1L42.2 43.4334L34.0667 54.5334C33.7 55.0667 33.7333 55.8 34.2 56.2667C34.7 56.7667 35.5333 56.8 36.0667 56.3L53.2667 40.8667C54.3667 39.8667 53.7667 38.0334 52.2667 37.9L38.7667 36.5667L46.9 25.4667C47.2667 24.9334 47.2333 24.2 46.7667 23.7334C46.5197 23.4884 46.1878 23.3482 45.84 23.342C45.4923 23.3358 45.1555 23.4641 44.9 23.7L27.7 39.1334C26.6333 40.1334 27.2333 41.9667 28.7 42.1Z",
    fill: "url(#paint1_linear_18_45)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_45",
    x1: 40.5,
    y1: 10,
    x2: 40.5,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB703"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_45",
    x1: 40.4947,
    y1: 23.3418,
    x2: 40.4947,
    y2: 56.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB703"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8500"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumo);
export default __webpack_public_path__ + "static/media/consumo.53ef143bae549c096a23dad8706619f2.svg";
export { ForwardRef as ReactComponent };